import styled from 'styled-components'
import PopoverMenu from 'src/components/PopoverMenu'
import { ScreenSizes } from 'src/styles'

export const Wrapper = styled.div``

Wrapper.displayName = 'Wrapper'

export const List = styled(PopoverMenu)`
  min-width: 14.5rem !important;
  top: 100% !important;
  left: 0 !important;

  @media (min-width: ${ScreenSizes.md}) {
    left: auto !important;
  }
`

List.displayName = 'List'

export const ListItem = styled.button`
  transition: background 0.26s ease-in-out;

  &:hover {
    background-color: var(--gray-300);
  }

  &:focus {
    outline: 2px solid var(--blue);
    outline-offset: -2px;
  }
`

ListItem.displayName = 'ListItem'
